import { render, staticRenderFns } from "./collectionDeta.vue?vue&type=template&id=58f26d9e&scoped=true"
import script from "./collectionDeta.vue?vue&type=script&lang=js"
export * from "./collectionDeta.vue?vue&type=script&lang=js"
import style0 from "./collectionDeta.vue?vue&type=style&index=0&id=58f26d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f26d9e",
  null
  
)

export default component.exports